import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static targets = ['confirmation']
  static values = { destinations: Object, contents: String, hub: String }

  declare readonly confirmationTarget: HTMLElement
  declare readonly destinationsValue: Record<string, string>
  declare readonly contentsValue: string
  declare readonly hubValue: string

  connect(): void {
    this.updateConfirmation()
  }

  updateConfirmation(): void {
    const selected = this.element.querySelector<HTMLInputElement>(
      'input[name="destination_dock_id"]:checked'
    )
    const destination =
      this.destinationsValue[selected?.value ?? ''] ?? `the selected ${this.hubValue} dock`
    this.confirmationTarget.textContent = `Move ${this.contentsValue} to ${destination}?`
  }
}
